module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The NHS, mainly the entire Southmead workforce.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The Knowle West Media Centre Community")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Captain Tom’s hard work to support the NHS also inspired me.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("All of the people that don’t wish to have their names published. But they know who they are.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0